import type { LineOutcomeSB } from '@mwl/core-lib';

import type { MarketBlockRow } from './MarketBlock.types';

export const formatMarketRow = (outcomes: Array<LineOutcomeSB>): MarketBlockRow => {
  return {
    outcomes,
  };
};

export const convertOutcomesToMatrix = (list: Array<LineOutcomeSB>, elementsPerSubArray: number) => {
  const matrix: Array<MarketBlockRow> = [];

  let index: number;
  let row: number;

  for (index = 0, row = -1; index < list.length; index += 1) {
    if (index % elementsPerSubArray === 0) {
      row += 1;
      matrix[row] = formatMarketRow([]);
    }

    matrix[row].outcomes.push(list[index]);
  }

  return matrix;
};
